import { PsDate } from '../../../shared/model/PsDate';
import { PsWorker } from './PsWorker';
import { PsResourceDocumentationState } from '../../../shared/model/resource/PsResourceDocumentationState';
import { Compare } from '../../../shared/compare/Compare';
import { PsWork } from './PsWork';
import WorkerState from '../../../shared/model/WorkerState';

export class PsPresence {

    _id; // number
    _date; // PsDate
    _work; // PsWork
    _worker; // PsWorker
    _workerDocumentationState; // PsResourceDocumentationState
    _saved; // boolean

    constructor(
        id,
        date,
        work,
        worker,
        workerDocumentationState,
        saved,
    ) {
        this._id = id;
        this._date = date;
        this._work = work;
        this._worker = worker;
        this._workerDocumentationState = workerDocumentationState;
        this._saved = saved;
    }

    static arrayFromBackend(presences) {
        return presences.map((p) => PsPresence.fromBackend(p));
    }

    static fromBackend(presence) {
        return new this(
            presence.id,
            PsDate.fromDate(presence.date),
            presence.construction ? PsWork.fromBackend(presence.construction) : null,
            PsWorker.fromBackend(presence.worker),
            presence.worker_documentation_state
                ? PsResourceDocumentationState.fromAPIDocumentationState(presence.worker_documentation_state)
                : null,
            true,
        );
    }

    static fromWorker(worker) {
        return new this(
            worker.id(),
            PsDate.fromNow(),
            null,
            worker,
            null,
            false,
        );
    }

    static presencesByMonth(presences) {
        const presencesByMonth = [];
        presences.forEach(function(presence) {
            const presenceDay = Number(presence.date.split('-')[2]);
            const presenceByMonth = presencesByMonth.find(pbm => pbm.worker.id() === presence.worker.id);
            if ( presenceByMonth ) {
                presenceByMonth.days = [...presenceByMonth.days, presenceDay];
            } else {
                presencesByMonth.push({
                    worker: PsWorker.fromBackend(presence.worker),
                    days: [presenceDay],
                });
            }
        });
        return presencesByMonth;
    }

    static sortPresencesByWorkerDni(presences, ascSort) {
        let compareFn;
        compareFn = (presenceA, presenceB) => {
            const workerA = presenceA.worker;
            const workerB = presenceB.worker;
            const dniA = workerA.dni();
            const dniB = workerB.dni();
            return Compare.compareStrings(dniA, dniB, ascSort);
        };

        return Object
            .entries(presences)
            .map(([presenceKey, presence]) => ( { ...presence, id: presenceKey } ))
            .sort(compareFn);
    }

    static sortPresencesByWorkerName(presences, ascSort) {
        let compareFn;
        compareFn = (presenceA, presenceB) => {
            const workerA = presenceA.worker;
            const workerB = presenceB.worker;
            const completeNameA = workerA.completeName();
            const completeNameB = workerB.completeName();
            return Compare.compareStrings(completeNameA, completeNameB, ascSort);
        };

        return Object
            .entries(presences)
            .map(([presenceKey, presence]) => ( { ...presence, id: presenceKey } ))
            .sort(compareFn);
    }

    static sortPresencesByWorkerCompany(presences, ascSort) {
        let compareFn;
        compareFn = (presenceA, presenceB) => {
            const workerA = presenceA.worker;
            const workerB = presenceB.worker;
            const companyWorkerA = workerA.company().name();
            const companyWorkerB = workerB.company().name();
            return Compare.compareStrings(companyWorkerA, companyWorkerB, ascSort);
        };

        return Object
            .entries(presences)
            .map(([presenceKey, presence]) => ( { ...presence, id: presenceKey } ))
            .sort(compareFn);
    }

    id() {
        return this._id;
    }

    date() {
        return this._date;
    }

    worker() {
        return this._worker;
    }

    workerId() {
        return this.worker().id();
    }

    workerCompleteName() {
        return this.worker().completeName();
    }

    isWorkerActive() {
        return this.worker().state() === WorkerState.ACTIVE
    }

    isWorkerPresence(workerId) {
        return this.workerId() === workerId;
    }

    hasBeenSaved() {
        return this._saved;
    }

    equals(presence) {
        return this.id() === presence.id();
    }

    equalsWorker(presence) {
        return this.workerId() === presence.workerId();
    }

    workerCompanyName() {
        return this.worker().company().name();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/PsPresence.js